import { useState } from "react"
import classNames from "classnames"
import * as Icons from "@nova/component-icons"
import { ToggleSwitch } from "@nova/component-toggle-switch"
import { useMapTerrain } from "../control/useMapStyles"
import { useGlobalTerrainData } from "../GlobalTerrainManager"

const STYLES = {
    dark: {
        base: "border-white-300 bg-black-600 hover:border-white-400 hover:bg-gray-900",
        active: "border-blue-500 bg-black-600 hover:bg-gray-900",
        disabled: "disabled:border-gray-700 disabled:bg-black-800",
        iconBase: "text-white-800 group-hover:text-gray-0",
    },
    light: {
        base: "border-black-300 bg-white-500 hover:border-black-400 hover:bg-white-1000",
        active: "border-blue-500 bg-white-500 hover:bg-white-1000",
        disabled: "disabled:border-black-300 disabled:bg-white-600",
        iconBase: "text-black-600 group-hover:text-gray-900",
    },
}

type Props = { isLight?: boolean }

export const MapTerrainButton = ({ isLight = false }: Props) => {
    const terrain = useMapTerrain()
    const { isDisabled } = useGlobalTerrainData(["isDisabled"])
    const [isHovered, setIsHovered] = useState(false)

    const isOn = terrain.val
    const showSwitch = !isDisabled && (isOn || isHovered)
    const style = STYLES[isLight ? "light" : "dark"]

    return (
        <button
            type="button"
            aria-label="Toggle 3D terrain"
            aria-pressed={isOn}
            disabled={isDisabled}
            onClick={terrain.flip}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={classNames(
                "group h-9 flex items-center justify-center gap-1 border rounded-[1.125rem] px-3 focus:outline-none",
                "disabled:cursor-not-allowed disabled:opacity-60",
                style.disabled,
                isOn ? style.active : style.base
            )}
        >
            <Icons.SmallIcon Icon={Icons.useAltitude} className={style.iconBase} />
            <small className={isLight ? "text-gray-900" : "text-gray-0"}>
                {isOn ? "3D" : "2D"}
            </small>
            <div
                className={classNames(
                    "-ml-1 overflow-hidden transition-[width] duration-150 ease-out",
                    showSwitch ? "w-8" : "w-0"
                )}
            >
                <ToggleSwitch
                    isToggled={isOn}
                    setIsToggled={() => {}}
                    isLight={isLight}
                    ballStyle="bg-blue-500"
                    className="pointer-events-none"
                />
            </div>
        </button>
    )
}
